// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from '@hey-api/client-fetch';
import type { HealthzApiV1HealthzGetData, GetUserPlaylistsApiV1PlaylistsGetData, GetUserPlaylistsApiV1PlaylistsGetResponse, CreatePlaylistApiV1PlaylistsPostData, CreatePlaylistApiV1PlaylistsPostResponse, CreatePlaylistApiV1PlaylistsPostError, GetPublicPlaylistsApiV1PlaylistsPublicGetData, GetPublicPlaylistsApiV1PlaylistsPublicGetResponse, DownloadPlaylistApiV1PlaylistsPlaylistIdDownloadPostData, DownloadPlaylistApiV1PlaylistsPlaylistIdDownloadPostError, AddVideoToPlaylistApiV1PlaylistsPlaylistIdVideosPostData, AddVideoToPlaylistApiV1PlaylistsPlaylistIdVideosPostResponse, AddVideoToPlaylistApiV1PlaylistsPlaylistIdVideosPostError, DeleteVideoFromPlaylistApiV1PlaylistsPlaylistIdVideosVideoIdDeleteData, DeleteVideoFromPlaylistApiV1PlaylistsPlaylistIdVideosVideoIdDeleteResponse, DeleteVideoFromPlaylistApiV1PlaylistsPlaylistIdVideosVideoIdDeleteError, DeletePlaylistApiV1PlaylistsIdDeleteData, DeletePlaylistApiV1PlaylistsIdDeleteResponse, DeletePlaylistApiV1PlaylistsIdDeleteError, UpdatePlaylistApiV1PlaylistsPlaylistIdPatchData, UpdatePlaylistApiV1PlaylistsPlaylistIdPatchResponse, UpdatePlaylistApiV1PlaylistsPlaylistIdPatchError, GetClipApiV1ClipGetData, GetClipApiV1ClipGetResponse, GetClipApiV1ClipGetError, GetBoxscoreApiV1BoxscoreGameIdGetData, GetBoxscoreApiV1BoxscoreGameIdGetResponse, GetBoxscoreApiV1BoxscoreGameIdGetError, GetStandingsApiV1NbaStandingsGetData, GetStandingsApiV1NbaStandingsGetResponse, GetStandingsApiV1NbaStandingsGetError, GetLeagueLeadersApiV1NbaLeadersGetData, GetLeagueLeadersApiV1NbaLeadersGetResponse, GetLeagueLeadersApiV1NbaLeadersGetError, GetNbaTeamsApiV1NbaTeamsGetData, GetNbaTeamsApiV1NbaTeamsGetResponse, GetNbaPlayersApiV1NbaPlayersGetData, GetNbaPlayersApiV1NbaPlayersGetResponse, GetNbaPlayersApiV1NbaPlayersGetError, GetNbaPlayersPbpApiV1NbaPlayersPlayerIdPbpGetData, GetNbaPlayersPbpApiV1NbaPlayersPlayerIdPbpGetResponse, GetNbaPlayersPbpApiV1NbaPlayersPlayerIdPbpGetError, GetNbaPlayersPbpBatchApiV1NbaPlayersPbpBatchPostData, GetNbaPlayersPbpBatchApiV1NbaPlayersPbpBatchPostResponse, GetNbaPlayersPbpBatchApiV1NbaPlayersPbpBatchPostError, GetNbaGamesApiV1NbaGamesGetData, GetNbaGamesApiV1NbaGamesGetResponse, GetNbaGamesApiV1NbaGamesGetError, GetNbaScheduleGamesApiV1NbaGamesScheduleGetData, GetNbaScheduleGamesApiV1NbaGamesScheduleGetResponse, GetNbaScheduleGamesApiV1NbaGamesScheduleGetError, GetNbaLiveGamesApiV1NbaGamesLiveGetData, GetNbaLiveGamesApiV1NbaGamesLiveGetResponse, GetNbaGamePbpApiV1NbaGamesGameIdPbpGetData, GetNbaGamePbpApiV1NbaGamesGameIdPbpGetResponse, GetNbaGamePbpApiV1NbaGamesGameIdPbpGetError, GetNbaGamesPbpBatchApiV1NbaGamesPbpBatchPostData, GetNbaGamesPbpBatchApiV1NbaGamesPbpBatchPostResponse, GetNbaGamesPbpBatchApiV1NbaGamesPbpBatchPostError, GetStandingsApiV1WnbaStandingsGetData, GetStandingsApiV1WnbaStandingsGetResponse, GetStandingsApiV1WnbaStandingsGetError, GetLeagueLeadersApiV1WnbaLeadersGetData, GetLeagueLeadersApiV1WnbaLeadersGetResponse, GetLeagueLeadersApiV1WnbaLeadersGetError, GetWnbaTeamsApiV1WnbaTeamsGetData, GetWnbaTeamsApiV1WnbaTeamsGetResponse, GetWnbaPlayersApiV1WnbaPlayersGetData, GetWnbaPlayersApiV1WnbaPlayersGetResponse, GetWnbaPlayersApiV1WnbaPlayersGetError, GetWnbaPlayersPbpApiV1WnbaPlayersPlayerIdPbpGetData, GetWnbaPlayersPbpApiV1WnbaPlayersPlayerIdPbpGetResponse, GetWnbaPlayersPbpApiV1WnbaPlayersPlayerIdPbpGetError, GetWnbaPlayersPbpBatchApiV1WnbaPlayersPbpBatchPostData, GetWnbaPlayersPbpBatchApiV1WnbaPlayersPbpBatchPostResponse, GetWnbaPlayersPbpBatchApiV1WnbaPlayersPbpBatchPostError, GetWnbaGamesApiV1WnbaGamesGetData, GetWnbaGamesApiV1WnbaGamesGetResponse, GetWnbaGamesApiV1WnbaGamesGetError, GetWnbaScheduleGamesApiV1WnbaGamesScheduleGetData, GetWnbaScheduleGamesApiV1WnbaGamesScheduleGetResponse, GetWnbaScheduleGamesApiV1WnbaGamesScheduleGetError, GetWnbaLiveGamesApiV1WnbaGamesLiveGetData, GetWnbaLiveGamesApiV1WnbaGamesLiveGetResponse, GetWnbaGamePbpApiV1WnbaGamesGameIdPbpGetData, GetWnbaGamePbpApiV1WnbaGamesGameIdPbpGetResponse, GetWnbaGamePbpApiV1WnbaGamesGameIdPbpGetError, GetWnbaGamesPbpBatchApiV1WnbaGamesPbpBatchPostData, GetWnbaGamesPbpBatchApiV1WnbaGamesPbpBatchPostResponse, GetWnbaGamesPbpBatchApiV1WnbaGamesPbpBatchPostError } from './types.gen';
import { client as _heyApiClient } from './client.gen';
import { getUserPlaylistsApiV1PlaylistsGetResponseTransformer, getPublicPlaylistsApiV1PlaylistsPublicGetResponseTransformer, getNbaPlayersPbpApiV1NbaPlayersPlayerIdPbpGetResponseTransformer, getNbaPlayersPbpBatchApiV1NbaPlayersPbpBatchPostResponseTransformer, getNbaGamesApiV1NbaGamesGetResponseTransformer, getNbaScheduleGamesApiV1NbaGamesScheduleGetResponseTransformer, getNbaGamePbpApiV1NbaGamesGameIdPbpGetResponseTransformer, getNbaGamesPbpBatchApiV1NbaGamesPbpBatchPostResponseTransformer, getWnbaPlayersPbpApiV1WnbaPlayersPlayerIdPbpGetResponseTransformer, getWnbaPlayersPbpBatchApiV1WnbaPlayersPbpBatchPostResponseTransformer, getWnbaGamesApiV1WnbaGamesGetResponseTransformer, getWnbaScheduleGamesApiV1WnbaGamesScheduleGetResponseTransformer, getWnbaGamePbpApiV1WnbaGamesGameIdPbpGetResponseTransformer, getWnbaGamesPbpBatchApiV1WnbaGamesPbpBatchPostResponseTransformer } from './transformers.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Healthz
 */
export const healthzApiV1HealthzGet = <ThrowOnError extends boolean = false>(options?: Options<HealthzApiV1HealthzGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/api/v1/healthz',
        ...options
    });
};

/**
 * Get User Playlists
 */
export const getUserPlaylistsApiV1PlaylistsGet = <ThrowOnError extends boolean = false>(options?: Options<GetUserPlaylistsApiV1PlaylistsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetUserPlaylistsApiV1PlaylistsGetResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        responseTransformer: getUserPlaylistsApiV1PlaylistsGetResponseTransformer,
        url: '/api/v1/playlists',
        ...options
    });
};

/**
 * Create Playlist
 */
export const createPlaylistApiV1PlaylistsPost = <ThrowOnError extends boolean = false>(options: Options<CreatePlaylistApiV1PlaylistsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreatePlaylistApiV1PlaylistsPostResponse, CreatePlaylistApiV1PlaylistsPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/playlists',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Public Playlists
 */
export const getPublicPlaylistsApiV1PlaylistsPublicGet = <ThrowOnError extends boolean = false>(options?: Options<GetPublicPlaylistsApiV1PlaylistsPublicGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPublicPlaylistsApiV1PlaylistsPublicGetResponse, unknown, ThrowOnError>({
        responseTransformer: getPublicPlaylistsApiV1PlaylistsPublicGetResponseTransformer,
        url: '/api/v1/playlists/public',
        ...options
    });
};

/**
 * Download Playlist
 */
export const downloadPlaylistApiV1PlaylistsPlaylistIdDownloadPost = <ThrowOnError extends boolean = false>(options: Options<DownloadPlaylistApiV1PlaylistsPlaylistIdDownloadPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, DownloadPlaylistApiV1PlaylistsPlaylistIdDownloadPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/playlists/{playlist_id}/download',
        ...options
    });
};

/**
 * Add Video To Playlist
 */
export const addVideoToPlaylistApiV1PlaylistsPlaylistIdVideosPost = <ThrowOnError extends boolean = false>(options: Options<AddVideoToPlaylistApiV1PlaylistsPlaylistIdVideosPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddVideoToPlaylistApiV1PlaylistsPlaylistIdVideosPostResponse, AddVideoToPlaylistApiV1PlaylistsPlaylistIdVideosPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/playlists/{playlist_id}/videos',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete Video From Playlist
 */
export const deleteVideoFromPlaylistApiV1PlaylistsPlaylistIdVideosVideoIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteVideoFromPlaylistApiV1PlaylistsPlaylistIdVideosVideoIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteVideoFromPlaylistApiV1PlaylistsPlaylistIdVideosVideoIdDeleteResponse, DeleteVideoFromPlaylistApiV1PlaylistsPlaylistIdVideosVideoIdDeleteError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/playlists/{playlist_id}/videos/{video_id}',
        ...options
    });
};

/**
 * Delete Playlist
 */
export const deletePlaylistApiV1PlaylistsIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeletePlaylistApiV1PlaylistsIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeletePlaylistApiV1PlaylistsIdDeleteResponse, DeletePlaylistApiV1PlaylistsIdDeleteError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/playlists/{id}',
        ...options
    });
};

/**
 * Update Playlist
 */
export const updatePlaylistApiV1PlaylistsPlaylistIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdatePlaylistApiV1PlaylistsPlaylistIdPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdatePlaylistApiV1PlaylistsPlaylistIdPatchResponse, UpdatePlaylistApiV1PlaylistsPlaylistIdPatchError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/playlists/{playlist_id}',
        ...options
    });
};

/**
 * Get Clip
 */
export const getClipApiV1ClipGet = <ThrowOnError extends boolean = false>(options: Options<GetClipApiV1ClipGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetClipApiV1ClipGetResponse, GetClipApiV1ClipGetError, ThrowOnError>({
        url: '/api/v1/clip',
        ...options
    });
};

/**
 * Get Boxscore
 */
export const getBoxscoreApiV1BoxscoreGameIdGet = <ThrowOnError extends boolean = false>(options: Options<GetBoxscoreApiV1BoxscoreGameIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBoxscoreApiV1BoxscoreGameIdGetResponse, GetBoxscoreApiV1BoxscoreGameIdGetError, ThrowOnError>({
        url: '/api/v1/boxscore/{game_id}',
        ...options
    });
};

/**
 * Get Standings
 */
export const getStandingsApiV1NbaStandingsGet = <ThrowOnError extends boolean = false>(options?: Options<GetStandingsApiV1NbaStandingsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetStandingsApiV1NbaStandingsGetResponse, GetStandingsApiV1NbaStandingsGetError, ThrowOnError>({
        url: '/api/v1/nba/standings',
        ...options
    });
};

/**
 * Get League Leaders
 */
export const getLeagueLeadersApiV1NbaLeadersGet = <ThrowOnError extends boolean = false>(options: Options<GetLeagueLeadersApiV1NbaLeadersGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLeagueLeadersApiV1NbaLeadersGetResponse, GetLeagueLeadersApiV1NbaLeadersGetError, ThrowOnError>({
        url: '/api/v1/nba/leaders',
        ...options
    });
};

/**
 * Get Nba Teams
 */
export const getNbaTeamsApiV1NbaTeamsGet = <ThrowOnError extends boolean = false>(options?: Options<GetNbaTeamsApiV1NbaTeamsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetNbaTeamsApiV1NbaTeamsGetResponse, unknown, ThrowOnError>({
        url: '/api/v1/nba/teams',
        ...options
    });
};

/**
 * Get Nba Players
 */
export const getNbaPlayersApiV1NbaPlayersGet = <ThrowOnError extends boolean = false>(options?: Options<GetNbaPlayersApiV1NbaPlayersGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetNbaPlayersApiV1NbaPlayersGetResponse, GetNbaPlayersApiV1NbaPlayersGetError, ThrowOnError>({
        url: '/api/v1/nba/players',
        ...options
    });
};

/**
 * Get Nba Players Pbp
 */
export const getNbaPlayersPbpApiV1NbaPlayersPlayerIdPbpGet = <ThrowOnError extends boolean = false>(options: Options<GetNbaPlayersPbpApiV1NbaPlayersPlayerIdPbpGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetNbaPlayersPbpApiV1NbaPlayersPlayerIdPbpGetResponse, GetNbaPlayersPbpApiV1NbaPlayersPlayerIdPbpGetError, ThrowOnError>({
        responseTransformer: getNbaPlayersPbpApiV1NbaPlayersPlayerIdPbpGetResponseTransformer,
        url: '/api/v1/nba/players/{player_id}/pbp',
        ...options
    });
};

/**
 * Get Nba Players Pbp Batch
 */
export const getNbaPlayersPbpBatchApiV1NbaPlayersPbpBatchPost = <ThrowOnError extends boolean = false>(options: Options<GetNbaPlayersPbpBatchApiV1NbaPlayersPbpBatchPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetNbaPlayersPbpBatchApiV1NbaPlayersPbpBatchPostResponse, GetNbaPlayersPbpBatchApiV1NbaPlayersPbpBatchPostError, ThrowOnError>({
        responseTransformer: getNbaPlayersPbpBatchApiV1NbaPlayersPbpBatchPostResponseTransformer,
        url: '/api/v1/nba/players/pbp/batch',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Nba Games
 */
export const getNbaGamesApiV1NbaGamesGet = <ThrowOnError extends boolean = false>(options?: Options<GetNbaGamesApiV1NbaGamesGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetNbaGamesApiV1NbaGamesGetResponse, GetNbaGamesApiV1NbaGamesGetError, ThrowOnError>({
        responseTransformer: getNbaGamesApiV1NbaGamesGetResponseTransformer,
        url: '/api/v1/nba/games',
        ...options
    });
};

/**
 * Get Nba Schedule Games
 */
export const getNbaScheduleGamesApiV1NbaGamesScheduleGet = <ThrowOnError extends boolean = false>(options?: Options<GetNbaScheduleGamesApiV1NbaGamesScheduleGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetNbaScheduleGamesApiV1NbaGamesScheduleGetResponse, GetNbaScheduleGamesApiV1NbaGamesScheduleGetError, ThrowOnError>({
        responseTransformer: getNbaScheduleGamesApiV1NbaGamesScheduleGetResponseTransformer,
        url: '/api/v1/nba/games/schedule',
        ...options
    });
};

/**
 * Get Nba Live Games
 */
export const getNbaLiveGamesApiV1NbaGamesLiveGet = <ThrowOnError extends boolean = false>(options?: Options<GetNbaLiveGamesApiV1NbaGamesLiveGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetNbaLiveGamesApiV1NbaGamesLiveGetResponse, unknown, ThrowOnError>({
        url: '/api/v1/nba/games/live',
        ...options
    });
};

/**
 * Get Nba Game Pbp
 */
export const getNbaGamePbpApiV1NbaGamesGameIdPbpGet = <ThrowOnError extends boolean = false>(options: Options<GetNbaGamePbpApiV1NbaGamesGameIdPbpGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetNbaGamePbpApiV1NbaGamesGameIdPbpGetResponse, GetNbaGamePbpApiV1NbaGamesGameIdPbpGetError, ThrowOnError>({
        responseTransformer: getNbaGamePbpApiV1NbaGamesGameIdPbpGetResponseTransformer,
        url: '/api/v1/nba/games/{game_id}/pbp',
        ...options
    });
};

/**
 * Get Nba Games Pbp Batch
 */
export const getNbaGamesPbpBatchApiV1NbaGamesPbpBatchPost = <ThrowOnError extends boolean = false>(options: Options<GetNbaGamesPbpBatchApiV1NbaGamesPbpBatchPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetNbaGamesPbpBatchApiV1NbaGamesPbpBatchPostResponse, GetNbaGamesPbpBatchApiV1NbaGamesPbpBatchPostError, ThrowOnError>({
        responseTransformer: getNbaGamesPbpBatchApiV1NbaGamesPbpBatchPostResponseTransformer,
        url: '/api/v1/nba/games/pbp/batch',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Standings
 */
export const getStandingsApiV1WnbaStandingsGet = <ThrowOnError extends boolean = false>(options?: Options<GetStandingsApiV1WnbaStandingsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetStandingsApiV1WnbaStandingsGetResponse, GetStandingsApiV1WnbaStandingsGetError, ThrowOnError>({
        url: '/api/v1/wnba/standings',
        ...options
    });
};

/**
 * Get League Leaders
 */
export const getLeagueLeadersApiV1WnbaLeadersGet = <ThrowOnError extends boolean = false>(options: Options<GetLeagueLeadersApiV1WnbaLeadersGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLeagueLeadersApiV1WnbaLeadersGetResponse, GetLeagueLeadersApiV1WnbaLeadersGetError, ThrowOnError>({
        url: '/api/v1/wnba/leaders',
        ...options
    });
};

/**
 * Get Wnba Teams
 */
export const getWnbaTeamsApiV1WnbaTeamsGet = <ThrowOnError extends boolean = false>(options?: Options<GetWnbaTeamsApiV1WnbaTeamsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWnbaTeamsApiV1WnbaTeamsGetResponse, unknown, ThrowOnError>({
        url: '/api/v1/wnba/teams',
        ...options
    });
};

/**
 * Get Wnba Players
 */
export const getWnbaPlayersApiV1WnbaPlayersGet = <ThrowOnError extends boolean = false>(options?: Options<GetWnbaPlayersApiV1WnbaPlayersGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWnbaPlayersApiV1WnbaPlayersGetResponse, GetWnbaPlayersApiV1WnbaPlayersGetError, ThrowOnError>({
        url: '/api/v1/wnba/players',
        ...options
    });
};

/**
 * Get Wnba Players Pbp
 */
export const getWnbaPlayersPbpApiV1WnbaPlayersPlayerIdPbpGet = <ThrowOnError extends boolean = false>(options: Options<GetWnbaPlayersPbpApiV1WnbaPlayersPlayerIdPbpGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWnbaPlayersPbpApiV1WnbaPlayersPlayerIdPbpGetResponse, GetWnbaPlayersPbpApiV1WnbaPlayersPlayerIdPbpGetError, ThrowOnError>({
        responseTransformer: getWnbaPlayersPbpApiV1WnbaPlayersPlayerIdPbpGetResponseTransformer,
        url: '/api/v1/wnba/players/{player_id}/pbp',
        ...options
    });
};

/**
 * Get Wnba Players Pbp Batch
 */
export const getWnbaPlayersPbpBatchApiV1WnbaPlayersPbpBatchPost = <ThrowOnError extends boolean = false>(options: Options<GetWnbaPlayersPbpBatchApiV1WnbaPlayersPbpBatchPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetWnbaPlayersPbpBatchApiV1WnbaPlayersPbpBatchPostResponse, GetWnbaPlayersPbpBatchApiV1WnbaPlayersPbpBatchPostError, ThrowOnError>({
        responseTransformer: getWnbaPlayersPbpBatchApiV1WnbaPlayersPbpBatchPostResponseTransformer,
        url: '/api/v1/wnba/players/pbp/batch',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Wnba Games
 */
export const getWnbaGamesApiV1WnbaGamesGet = <ThrowOnError extends boolean = false>(options?: Options<GetWnbaGamesApiV1WnbaGamesGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWnbaGamesApiV1WnbaGamesGetResponse, GetWnbaGamesApiV1WnbaGamesGetError, ThrowOnError>({
        responseTransformer: getWnbaGamesApiV1WnbaGamesGetResponseTransformer,
        url: '/api/v1/wnba/games',
        ...options
    });
};

/**
 * Get Wnba Schedule Games
 */
export const getWnbaScheduleGamesApiV1WnbaGamesScheduleGet = <ThrowOnError extends boolean = false>(options?: Options<GetWnbaScheduleGamesApiV1WnbaGamesScheduleGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWnbaScheduleGamesApiV1WnbaGamesScheduleGetResponse, GetWnbaScheduleGamesApiV1WnbaGamesScheduleGetError, ThrowOnError>({
        responseTransformer: getWnbaScheduleGamesApiV1WnbaGamesScheduleGetResponseTransformer,
        url: '/api/v1/wnba/games/schedule',
        ...options
    });
};

/**
 * Get Wnba Live Games
 */
export const getWnbaLiveGamesApiV1WnbaGamesLiveGet = <ThrowOnError extends boolean = false>(options?: Options<GetWnbaLiveGamesApiV1WnbaGamesLiveGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWnbaLiveGamesApiV1WnbaGamesLiveGetResponse, unknown, ThrowOnError>({
        url: '/api/v1/wnba/games/live',
        ...options
    });
};

/**
 * Get Wnba Game Pbp
 */
export const getWnbaGamePbpApiV1WnbaGamesGameIdPbpGet = <ThrowOnError extends boolean = false>(options: Options<GetWnbaGamePbpApiV1WnbaGamesGameIdPbpGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWnbaGamePbpApiV1WnbaGamesGameIdPbpGetResponse, GetWnbaGamePbpApiV1WnbaGamesGameIdPbpGetError, ThrowOnError>({
        responseTransformer: getWnbaGamePbpApiV1WnbaGamesGameIdPbpGetResponseTransformer,
        url: '/api/v1/wnba/games/{game_id}/pbp',
        ...options
    });
};

/**
 * Get Wnba Games Pbp Batch
 */
export const getWnbaGamesPbpBatchApiV1WnbaGamesPbpBatchPost = <ThrowOnError extends boolean = false>(options: Options<GetWnbaGamesPbpBatchApiV1WnbaGamesPbpBatchPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetWnbaGamesPbpBatchApiV1WnbaGamesPbpBatchPostResponse, GetWnbaGamesPbpBatchApiV1WnbaGamesPbpBatchPostError, ThrowOnError>({
        responseTransformer: getWnbaGamesPbpBatchApiV1WnbaGamesPbpBatchPostResponseTransformer,
        url: '/api/v1/wnba/games/pbp/batch',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};